import AppResource from './AppResource'

const BaseConfig = {
  localhost: {
    logo: AppResource.images.img_VIETINVOICE_logo,
    name: 'VIET-INVOICE',
    title: 'VIET-INVOICE - Giải pháp hóa đơn điện tử ',
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.icons.favicons.vietInvoice_favicon,
    },
    companyInfo: {
      name: 'CÔNG TY CỔ PHẦN iCORP',
      address:
        'Địa chỉ: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội.',
      headquarters:
        'VPGD: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội',
      hotline: '1900.0099',
      email: 'vietinvoice@icorp.vn',
    },
  },
  'tracuuhoadon.vietinvoice.vn': {
    logo: AppResource.images.img_VIETINVOICE_logo,
    name: 'VIET-INVOICE',
    title: 'VIET-INVOICE - Giải pháp hóa đơn điện tử ',
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.icons.favicons.vietInvoice_favicon,
    },
    companyInfo: {
      name: 'CÔNG TY CỔ PHẦN iCORP',
      address:
        'Địa chỉ: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội.',
      headquarters:
        'VPGD: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội',
      hotline: '1900.0099',
      email: 'vietinvoice@icorp.vn',
    },
  },
  'tracuupetro.vietinvoice.vn': {
    logo: AppResource.images.img_VIETINVOICE_logo,
    name: 'VIET-INVOICE',
    title: 'VIET-INVOICE - Giải pháp hóa đơn điện tử ',
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.icons.favicons.vietInvoice_favicon,
    },
    companyInfo: {
      name: 'CÔNG TY CỔ PHẦN iCORP',
      address:
        'Địa chỉ: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội.',
      headquarters:
        'VPGD: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội',
      hotline: '1900.0099',
      email: 'vietinvoice@icorp.vn',
    },
  },
  'tracuutuluc.vietinvoice.vn': {
    logo: AppResource.images.img_VIETINVOICE_logo,
    name: 'VIET-INVOICE',
    title: 'VIET-INVOICE - Giải pháp hóa đơn điện tử ',
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.icons.favicons.vietInvoice_favicon,
    },
    companyInfo: {
      name: 'CÔNG TY CỔ PHẦN iCORP',
      address:
        'Địa chỉ: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội.',
      headquarters:
        'VPGD: Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội',
      hotline: '1900.0099',
      email: 'vietinvoice@icorp.vn',
    },
  },
  'tracuu.igas.vn': {
    //  localhost: {
    logo: AppResource.images.img_igas_logo,
    name: 'IGAS',
    title: 'IGas Invoice',
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.icons.favicons.igas_favicon,
    },
    companyInfo: {
      name: 'CÔNG TY CỔ PHẦN GIẢI PHÁP SỐ IGAS',
      address:
        'Địa chỉ: Biệt thự A3-14, đường Hà Phong 3, khu đô thị Hà Phong, xã Mê Linh, thành phố Hà Nội, Việt Nam',
      // headquarters:
      //   'VPGD: Lô A3-14, Đường Hà Phong 3, Khu Đô Thị Hà Phong, Xã Thiên Lộc, Thành phố Hà Nội, Việt Nam',
      hotline: '1900.9110',
      // email: 'vietinvoice@icorp.vn',
    },
  },
  'tracuu.gohoadon.vn': {
    logo: AppResource.images.img_go_logo,
    name: 'GO',
    title: 'GO - Giải pháp hóa đơn điện tử ',
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.icons.favicons.go_favicon,
    },
    companyInfo: {
      name: 'Công ty Cổ phần Công nghệ Go Việt Nam',
      address:
        'Địa chỉ: Số 28 ngõ 8 Cầu Đơ 4, Phường Hà Đông, TP Hà Nội, Việt Nam.',
      headquarters:
        'VPGD: Số 28 ngõ 8 Cầu Đơ 4, Phường Hà Đông, TP Hà Nội, Việt Nam',
      hotline: '1900.0120',
      email: 'info@gohoadon.vn',
    },
  },
  // 'tracuuhoadon.vietinvoice.vn': {
  //   logo: AppResource.branding.vietinvoice_logo,
  //   secondLogo: AppResource.images.img_ICORP_logo,
  //   favicons: {
  //     rel: 'icon',
  //     type: 'image/x-icon',
  //     href: AppResource.branding.vietinvoice_ico,
  //   },
  //   name: 'VIETINVOICE',
  //   menubar: [
  //     {
  //       translateText: 'Introduction',
  //       link: 'https://vietinvoice.vn/gioi-thieu',
  //     },
  //     {
  //       translateText: 'Price list',
  //       link: 'https://vietinvoice.vn/bang-gia',
  //     },
  //     {
  //       translateText: 'Invoice template',
  //       link: 'https://vietinvoice.vn/mau-hoa-don',
  //     },
  //     {
  //       translateText: 'Document',
  //       link: 'https://vietinvoice.vn/van-ban',
  //     },
  //     {
  //       translateText: 'Customer',
  //       link: 'https://vietinvoice.vn/khach-hang',
  //     },
  //     {
  //       translateText: 'News',
  //       link: 'https://vietinvoice.vn/tin-tuc',
  //     },
  //     {
  //       translateText: 'Contact',
  //       link: 'https://vietinvoice.vn/lien-he',
  //     },
  //   ],
  //   introduceText: {
  //     title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
  //     content:
  //       'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
  //   },
  //   serviceCustomerPhone: [
  //     { label: '1900.0099', value: '19000099' },
  //     { label: '0988.399.516', value: '0988399516' },
  //   ],
  //   footer: {
  //     isHadFooter: true,
  //     content: {
  //       companyName: 'CÔNG TY CỔ PHẦN ICORP',
  //       address:
  //         'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
  //       hotline: '1900.0099',
  //     },
  //   },
  // },
  // 'tuluc.vietinvoice.vn': {
  //   logo: AppResource.branding.tuluc_ico,
  //   favicons: {
  //     rel: 'icon',
  //     type: 'image/x-icon',
  //     href: AppResource.branding.tuluc_ico,
  //   },
  //   name: 'TỰ LỰC',
  //   menubar: [],
  //   introduceText: {
  //     title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
  //     content:
  //       'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
  //   },
  //   serviceCustomerPhone: [
  //     { label: '1900.0099', value: '19000099' },
  //     { label: '0988.399.516', value: '0988399516' },
  //   ],
  // },
  // 'seen.vietinvoice.vn': {
  //   logo: AppResource.branding.seen_logo,
  //   favicons: {
  //     rel: 'icon',
  //     type: 'image/x-icon',
  //     href: AppResource.branding.seen_logo,
  //   },
  //   name: 'SEEN',
  //   menubar: [],
  //   introduceText: {
  //     title: 'Giải pháp hóa đơn điện tử seen',
  //     content:
  //       'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
  //   },
  //   serviceCustomerPhone: [
  //     { label: '1900.0099', value: '19000099' },
  //     { label: '0988.399.516', value: '0988399516' },
  //   ],
  // },
  // 'phusan.vietinvoice.vn': {
  //   logo: AppResource.branding.vietinvoice_logo,
  //   // secondLogo: AppResource.images.img_ICORP_logo,
  //   favicons: {
  //     rel: 'icon',
  //     type: 'image/x-icon',
  //     href: AppResource.branding.vietinvoice_ico,
  //   },
  //   name: 'VIETINVOICE',
  //   menubar: [],
  //   introduceText: {
  //     title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
  //     content:
  //       'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
  //   },
  //   serviceCustomerPhone: [
  //     { label: '1900.4751', value: '19004751' },
  //     { label: '0208.3607.668', value: '02083607668' },
  //   ],
  //   // footer: {
  //   //   isHadFooter: true,
  //   //   content: {
  //   //     companyName: 'CÔNG TY CỔ PHẦN ICORP',
  //   //     address:
  //   //       'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
  //   //     hotline: '1900.0099',
  //   //   },
  //   // },
  // },
  // 'uatphusan.vietinvoice.vn': {
  //   logo: AppResource.branding.vietinvoice_logo,
  //   // secondLogo: AppResource.images.img_ICORP_logo,
  //   favicons: {
  //     rel: 'icon',
  //     type: 'image/x-icon',
  //     href: AppResource.branding.vietinvoice_ico,
  //   },
  //   name: 'VIETINVOICE',
  //   menubar: [],
  //   introduceText: {
  //     title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
  //     content:
  //       'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
  //   },
  //   serviceCustomerPhone: [
  //     { label: '1900.4751', value: '19004751' },
  //     { label: '0208.3607.668', value: '02083607668' },
  //   ],
  //   // footer: {
  //   //   isHadFooter: true,
  //   //   content: {
  //   //     companyName: 'CÔNG TY CỔ PHẦN ICORP',
  //   //     address:
  //   //       'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
  //   //     hotline: '1900.0099',
  //   //   },
  //   // },
  // },
}
export default BaseConfig
